import React, { useState } from 'react';
import { ISpec } from '../../../helpers/Interface';
import { Divider, Grid, MenuItem, Stack } from '@mui/material';
import InputMuiCustom from '../../../../../components/common/inputs/InputMuiCustom';
import CustomSelect from '../../../../../components/common/SelectField';
import Button from '@mui/material/Button';

import { CustomButton } from '../../../../../components/common/button/CustomButtons';
interface Iprop {
  specModalData: ISpec;
  openModal: boolean;
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
  handleSpec: (e: any, specs: ISpec) => void;
  handleAppearance: (e: any, spec: ISpec) => void;
}
const SpecsInputs = (props: Iprop) => {
  const {
    specModalData,
    openModal,
    setOpenModal,
    handleSpec,
    handleAppearance,
  } = props;
  const [render, setRender] = useState<boolean>(false);

  return (
    <>
      <Grid
        container
        gap={3}
        columnGap={4}
        xs={12}
        sx={{ width: '80vw', alignItems: 'center', marginLeft: '4rem' }}
      >
        <Grid item xs={2}>
          <InputMuiCustom
            type="text"
            name="machine"
            placeholder="Machine"
            onBlur={(e) => handleSpec(e, specModalData)}
            defaultValue={specModalData.machine}
          />
        </Grid>
        {/* for ideal component  */}
        <Grid item xs={2}>
          <InputMuiCustom
            type="text"
            name="misp_ref_nohhhh"
            placeholder="MISP REF. NO"
            onBlur={(e) => handleSpec(e, specModalData)}
            defaultValue={specModalData.misp_ref_no}
          />
        </Grid>
        <Grid item xs={2}>
          <InputMuiCustom
            type="text"
            name="char_product"
            placeholder="Product Char."
            onBlur={(e) => handleSpec(e, specModalData)}
            defaultValue={specModalData.char_product}
          />
        </Grid>
        <Grid item xs={2}>
          <InputMuiCustom
            type="text"
            name="char_process"
            placeholder="Process Char."
            onBlur={(e) => handleSpec(e, specModalData)}
            defaultValue={specModalData.char_process}
          />
        </Grid>
        <Grid item xs={2}>
          <CustomSelect
            name={'special_character'}
            value={specModalData.special_character}
            label={'CLASS'}
            onChange={(e) => handleSpec(e, specModalData)}
          >
            <MenuItem value="">None</MenuItem>
            <MenuItem value="C">C-Critical</MenuItem>
            <MenuItem value="S">S-Significant</MenuItem>
          </CustomSelect>
        </Grid>
        <Grid item xs={2}>
          <InputMuiCustom
            type="text"
            name="methods_measure"
            placeholder="Evaluation"
            onBlur={(e) => handleSpec(e, specModalData)}
            defaultValue={specModalData.methods_measure}
          />
        </Grid>
        <Grid item xs={2}>
          <InputMuiCustom
            type="text"
            name="methods_size"
            placeholder="Sample Size"
            // className="section-input"
            onBlur={(e) => handleSpec(e, specModalData)}
            defaultValue={specModalData.methods_size}
          />
        </Grid>
        <Grid item xs={2}>
          <InputMuiCustom
            type="text"
            name="methods_by"
            placeholder="Sample Frequency"
            onBlur={(e) => handleSpec(e, specModalData)}
            defaultValue={specModalData.methods_by}
          />
        </Grid>
        <Grid item xs={2}>
          <InputMuiCustom
            type="text"
            name="recording"
            placeholder="Recording"
            onBlur={(e) => handleSpec(e, specModalData)}
            defaultValue={specModalData.recording}
          />
        </Grid>
        <Grid item xs={2}>
          <InputMuiCustom
            type="text"
            name="responsibility"
            placeholder="Inspection By"
            onBlur={(e) => handleSpec(e, specModalData)}
            defaultValue={specModalData.responsibility}
          />
        </Grid>
        <Grid item xs={2}>
          <InputMuiCustom
            type="text"
            name="methods_process" // control method or current process control
            placeholder="Control Method"
            onBlur={(e) => handleSpec(e, specModalData)}
            defaultValue={specModalData.methods_process}
          />
        </Grid>
        <Grid item xs={2}>
          <InputMuiCustom
            type="text"
            name="reaction_plan"
            placeholder="Reaction Plan"
            onBlur={(e) => handleSpec(e, specModalData)}
            defaultValue={specModalData.reaction_plan}
          />
        </Grid>

        {/* <Grid item xs={2}>
          <InputMuiCustom
            type="text"
            name="corrective_action"
            placeholder="Corrective Action"
            onBlur={(e) => handleSpec(e, specModalData)}
            defaultValue={specModalData.corrective_action}
          />
        </Grid> */}
        {/* <Grid item xs={2}>
          <InputMuiCustom
            type="text"
            name="process_capability"
            placeholder="Process Capability"
            onBlur={(e) => handleSpec(e, specModalData)}
            defaultValue={specModalData.process_capability}
          />
        </Grid> */}
      </Grid>

      <p
        style={{
          marginLeft: '0.5rem',
          marginTop: '2.3rem',
          fontWeight: 600,
          fontSize: '1.8rem',
        }}
      >
        Product/Process Specification/Tolerance
      </p>
      <Divider />
      <Stack
        mt={2}
        ml={4.2}
        p={1}
        spacing={2}
        direction="row"
        alignItems="center"
      >
        <InputMuiCustom
          type="text"
          sx={{ width: '350px' }}
          name="control_product"
          placeholder="Product/Process Specification/Tolerance"
          onChange={(e) => handleSpec(e, specModalData)}
          value={specModalData.control_product}
        />
        <Button
          sx={{
            fontSize: '2rem',
            backgroundColor: '#e9ecef',
          }}
          onClick={(e) => {
            if (specModalData.control_product) {
              specModalData.control_product += ' ± ';
              setRender((prev) => !prev);
            }
          }}
        >
          ±
        </Button>
        <Button
          sx={{
            fontSize: '2rem',
            backgroundColor: '#e9ecef',
          }}
          onClick={(e) => {
            if (specModalData.control_product) {
              specModalData.control_product += ' ~ ';
              setRender((prev) => !prev);
            }
          }}
        >
          ~
        </Button>
        <Button
          sx={{
            fontSize: '2rem',
            backgroundColor: '#e9ecef',
          }}
          onClick={(e) => {
            specModalData.control_product === null &&
              (specModalData.control_product = '');
            if (!/\b(Max)\b/gi.test(specModalData.control_product)) {
              specModalData.control_product += 'Min ';
              setRender((prev) => !prev);
            }
          }}
        >
          Min
        </Button>
        <Button
          sx={{
            fontSize: '2rem',
            backgroundColor: '#e9ecef',
          }}
          onClick={(e) => {
            specModalData.control_product === null &&
              (specModalData.control_product = '');
            if (!/\b(Min)\b/gi.test(specModalData.control_product)) {
              specModalData.control_product += 'Max ';
              setRender((prev) => !prev);
            }
          }}
        >
          Max
        </Button>
      </Stack>
    </>
  );
};

export default SpecsInputs;
